import { gql } from '@apollo/client';

import useQuery from '../../hooks/useQuery';
import permissions from '../../Apollo/permissions';

export const CHILD_ID_SET_QUERIES = {
  integration: {
    document: gql`
      query AuditLogChildIdSet($parentId: uuid!) {
        pipelines_by_pk(id: $parentId) {
          pipelineIntegrations: pipeline_integrations(where: { deletedAt: { _is_null: true } }) {
            integrationId
            integration {
              id
              name
            }
          }
        }
      }
    `,
    extractChildren: data =>
      (data?.pipelines_by_pk?.pipelineIntegrations ?? []).map(row => ({
        id: row.integrationId,
        name: row.integration?.name ?? row.integrationId,
      })),
  },
};

const SKIPPED_DOCUMENT = CHILD_ID_SET_QUERIES.integration.document;

export function useChildIdSet({ parentId, childType }) {
  const queryConfig = CHILD_ID_SET_QUERIES[childType];
  if (childType && !queryConfig) {
    throw new Error(`No child-id-set query for child type '${childType}' — add it to CHILD_ID_SET_QUERIES`);
  }

  // Apollo requires a document even when skipping, and there is no child type to pick one by;
  // any document will do because the query never runs.
  const { data, loading, error, isAllowed } = useQuery(queryConfig?.document ?? SKIPPED_DOCUMENT, {
    variables: { parentId },
    skip: !childType,
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-and-network',
    context: { permission: permissions.readPipeline },
  });

  const children = childType ? queryConfig.extractChildren(data) : [];

  return { children, ids: children.map(child => child.id), loading, error, isAllowed };
}
